// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__112ZW","range":"MonthRangeSwitch_range__32RpF","disabled":"MonthRangeSwitch_disabled__ZNhxK"};